import { produce } from "immer"
import { PROFILE_LOAD } from "./profile.actions"
import type { IProfileState, Profile, ProfileAction } from "./profile.types"

const profileInitialState: IProfileState = {
  profile: ""
}

export function profileReducer(currentState: IProfileState | undefined, action: ProfileAction): IProfileState {
  const state = currentState ?? profileInitialState
  switch (action.type) {
    case PROFILE_LOAD: {
      return loadProfile(state, action.payload as Profile)
    }
    default:
      return state
  }
}

function loadProfile(currentState: IProfileState, profile: Profile): IProfileState {
  return produce(currentState, (draftState: IProfileState) => {
    draftState.profile = profile
  })
}
